import { createSlice } from "@reduxjs/toolkit";
import { fetchUsers, bulkDeleteUsers, fetchUserHistory, fetchUserDetails } from "./thunk";

const initialState = {
  users: [],
  userHistory: [],
  userDetails: null, // Add userDetails to initial state
  pagination: {
    totalUsers: 0,
    page: 1,
    limit: 10,
    totalPages: 0,
  },
  loading: false,
  error: "",
  success: "",
};

const UsersSlice = createSlice({
  name: "Users",
  initialState,
  reducers: {
    resetUsersFlag(state) {
      state.success = null;
      state.error = null;
    },
    clearUserDetails(state) {
      state.userDetails = null; // Add reducer to clear user details
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Users Cases
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
        state.error = "";
        state.success = "";
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload && action.payload.data) {
          // Handle response structure: { error: false, msg: "...", data: { users: [...], pagination: {...} } }
          // or direct array: { error: false, msg: "...", data: [...] }
          if (Array.isArray(action.payload.data)) {
            state.users = action.payload.data;
            state.pagination = {
              ...state.pagination,
              totalUsers: action.payload.data.length,
              totalPages: 1
            };
          } else if (action.payload.data.users) {
            state.users = action.payload.data.users;

            const paginationData = action.payload.data.pagination || action.payload.data;

            state.pagination = {
              page: paginationData.page || state.pagination.page,
              limit: paginationData.limit || state.pagination.limit,
              totalPages: paginationData.totalPages ||
                Math.ceil((paginationData.total || paginationData.totalUsers || 0) /
                  (paginationData.limit || state.pagination.limit)),
              totalUsers: paginationData.total || paginationData.totalUsers ||
                paginationData.totalCount || action.payload.data.users.length
            };
          } else {
            state.users = [];
          }
        }
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch users";
      })

      // Fetch User Details Cases - ADD THIS SECTION
      .addCase(fetchUserDetails.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchUserDetails.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload && action.payload.data) {
          state.userDetails = action.payload.data; // Store user details data
        }
      })
      .addCase(fetchUserDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch user details";
        state.userDetails = null; // Clear user details on error
      })

      // Bulk Delete Users Cases
      .addCase(bulkDeleteUsers.pending, (state) => {
        state.loading = true;
        state.success = "";
        state.error = "";
      })
      .addCase(bulkDeleteUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.msg || "Users deleted successfully";
      })
      .addCase(bulkDeleteUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to delete users";
      })

      // Fetch User History Cases
      .addCase(fetchUserHistory.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchUserHistory.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload && action.payload.data) {
          state.userHistory = action.payload.data || [];
        }
      })
      .addCase(fetchUserHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch user history";
      });
  },
});

export const { resetUsersFlag, clearUserDetails } = UsersSlice.actions;
export default UsersSlice.reducer;